import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./ar.json";
import en from "./en.json";

export const SUPPORTED_LANGS = ["ar", "en"]; // 'ar' = Argentine Spanish, 'en' = English
export const DEFAULT_LANG = "ar";

i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export default i18n;
